exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n    display: flex;\r\n    flex: 1;\r\n    flex-direction: column;\r\n}\r\n\r\n.kendo-grid {\r\n    height:100%;\r\n    overflow: auto;\r\n}\r\n\r\n.ms-treeview {\r\n    margin: 10px;\r\n}\r\n\r\n.ms-treeview-item {\r\n    display: flex;\r\n    flex: 1 1 auto;\r\n    flex-direction: row;\r\n}\r\n\r\n.ms-treeview-checkbox {\r\n    margin-right: 5px;\r\n    margin-bottom: -2px;\r\n}\r\n\r\n.ms-treeview-selection {\r\n    margin-left: auto;\r\n    margin-right: 200px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/app/settings/settings-security/settings-security.component.css
// module id = 2437
// module chunks = 1